/**
 * Roles de usuario disponibles en la aplicación
 */
export const ROLES = {
  ADMIN: "ADMIN",
  TREASURER: "TESORERA",
  STOCK: "UNIFORMIDAD",
};

/**
 * Secciones disponibles para los learners
 */
export const SECTIONS = [
  "Castores",
  "Lobatos",
  "Scouts",
  "Escultas",
  "Rovers",
  "Scouters",
];
